import yup from 'core/utils/validators';

const { object, string, boolean } = yup;

export const phoneConfirmFormSchema = () =>
  object().shape({
    confirmation_code: string()
      .min(4, 'message_password_length')
      .required('message_password_required'),
    is_data_processing_consent_given: boolean(),
    is_credit_bureau_consent_given: boolean(),
  });
